import React, { Component } from 'react'
import { capitalizeFirstLetter } from '@disco/utils/string-utils'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import TextField from 'components/ui/text-field'
type Props = {
  typeName: string
  fieldName: string
  initialValue?: string
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type State = {
  name: string
}
/**
 * Modal dialog for renaming items with validation and confirmation
 * Provides a text field for entering new names with cancel/submit actions
 * @param typeName - The type of item being renamed (e.g., "playlist", "library")
 * @param fieldName - The name of the field being edited (defaults to "name")
 * @param initialValue - Initial value to populate in the text field
 * @param onSubmit - Callback function called when rename is confirmed
 * @param onCancel - Callback function called when dialog is cancelled
 */
export default class RenameDialog extends Component<Props, State> {
  static defaultProps: {
    fieldName: string
  } = {
    fieldName: 'name',
  }
  state: State = {
    name: this.props.initialValue || '',
  }
  _onNameChange: (e: any) => void = (e: any) =>
    this.setState({
      name: e.target.value,
    })
  _onSubmit: () => any = () => this.props.onSubmit(this.state.name)

  render(): React.ReactNode {
    const { typeName, fieldName, onCancel } = this.props
    return (
      <ModalWindow
        noPaddingBottom
        noMinHeight
        onClose={onCancel}
        width="small"
        header={<Heading>Rename {typeName}</Heading>}
        actions={
          <ButtonContainer alignRight>
            <Button caption="Cancel" onClick={onCancel} />
            <Button
              appearance="primary"
              caption="Rename"
              onClick={this._onSubmit}
              disabled={!this.state.name.trim()}
            />
          </ButtonContainer>
        }
        isOpen
      >
        <TextField
          autoFocus
          label={`${capitalizeFirstLetter(typeName)} ${fieldName}`}
          placeholder={`Enter ${fieldName}`}
          value={this.state.name}
          onChange={this._onNameChange}
        />
      </ModalWindow>
    )
  }
}
